import apiAnimals from "../config/api_animals";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiAnimals = axios.create({
//   baseURL: "http://localhost:8084",
// });

export function getWeightGainProjectionIndex(payload) {
  const {
    groupId,
    farmId,
    page,
    sorter,
    filters,
    withoutPagination,
    signal,
    ids,
  } = payload;

  if (withoutPagination) {
    return apiAnimals.post(
      `/bovexo/${groupId}/farms/${farmId}/weightGainProjections/list?withoutPagination=true`,
      ids,
      getHeaders(false, signal),
    );
  } else {
    const { field, order } = sorter;

    const orderS = order === "descend" ? "DESC" : "ASC";

    return apiAnimals.post(
      `/bovexo/${groupId}/farms/${farmId}/weightGainProjections/list?
     ${page ? `&page=${page - 1}` : ""}
     ${
       Object.entries(sorter).length > 0
         ? `&sort=${field}&direction=${orderS}`
         : ""
     }
     ${filters !== "" ? `&search=${filters}` : ""}`,
      ids,
      getHeaders(false, signal),
    );
  }
}

export function getWeightGainProjectionDrowpdown(payload) {
  const { groupId, farmId, signal } = payload;

  return apiAnimals.post(
    `/bovexo/${groupId}/farms/${farmId}/weightGainProjections/list?withoutPagination=true`,
    null,
    getHeaders(false, signal),
  );
}

export function getWeightGainProjectionGroupIndex(payload) {
  const { groupId, page, sorter, filters, withoutPagination, signal, ids } =
    payload;

  if (withoutPagination) {
    return apiAnimals.post(
      `/bovexo/${groupId}/weightGainProjections/list?withoutPagination=true`,
      ids,
      getHeaders(false, signal),
    );
  } else {
    const { field, order } = sorter;

    const orderS = order === "descend" ? "DESC" : "ASC";

    return apiAnimals.post(
      `/bovexo/${groupId}/weightGainProjections/list?
     ${page ? `&page=${page - 1}` : ""}
     ${
       Object.entries(sorter).length > 0
         ? `&sort=${field}&direction=${orderS}`
         : ""
     }
     ${filters !== "" ? `&search=${filters}` : ""}`,
      ids,
      getHeaders(false, signal),
    );
  }
}

export function getWeightGainProjectionShow(payload) {
  const { groupId, farmId, id, signal } = payload;
  if (!groupId || !farmId || !id) return;
  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/weightGainProjections/${id}`,
    getHeaders(false, signal),
  );
}

export function saveWeightGainProjection(payload) {
  const { groupId, farmId, id, weightGainProjection, signal } = payload;
  if (id != null) {
    return apiAnimals.patch(
      `/bovexo/${groupId}/farms/${farmId}/weightGainProjections/${id}`,
      weightGainProjection,
      getHeaders(false, signal),
    );
  } else {
    return apiAnimals.post(
      `/bovexo/${groupId}/farms/${farmId}/weightGainProjections`,
      weightGainProjection,
      getHeaders(false, signal),
    );
  }
}

export function saveWeightGainProjectionForGroup(payload) {
  const { groupId, id, weightGainProjection, signal } = payload;
  if (id != null) {
    return apiAnimals.patch(
      `/bovexo/${groupId}/weightGainProjections/${id}`,
      weightGainProjection,
      getHeaders(false, signal),
    );
  } else {
    return apiAnimals.post(
      `/bovexo/${groupId}/weightGainProjections`,
      weightGainProjection,
      getHeaders(false, signal),
    );
  }
}

export function inactivateWeightGainProjection(payload) {
  const { groupId, farmId, id, signal } = payload;

  if (!farmId) {
    return apiAnimals.patch(
      `/bovexo/${groupId}/weightGainProjections/${id}/inactivate`,
      {},
      getHeaders(false, signal),
    );
  }
  return apiAnimals.patch(
    `/bovexo/${groupId}/farms/${farmId}/weightGainProjections/${id}/inactivate`,
    {},
    getHeaders(false, signal),
  );
}

export function activateWeightGainProjection(payload) {
  const { groupId, farmId, id, signal } = payload;

  if (!farmId) {
    return apiAnimals.patch(
      `/bovexo/${groupId}/weightGainProjections/${id}/activate`,
      {},
      getHeaders(false, signal),
    );
  }
  return apiAnimals.patch(
    `/bovexo/${groupId}/farms/${farmId}/weightGainProjections/${id}/activate`,
    {},
    getHeaders(false, signal),
  );
}
